import * as React from 'react';
import Button from '@mui/material/Button';
import { lightBlue } from '@mui/material/colors';

export default function NextButton(props) {
  const { isDisabled, isLoading, title, sx, style, ...rest } = props;
  return (
      <Button
        variant="contained"
        {...rest}
        disabled={isDisabled}
        sx={{ bgcolor: lightBlue[500], ...sx }}
        style={{ color: 'white', ...style }}
      >
      {
        title != undefined && !isLoading ? title : isLoading ? "Loading..." : "Next"
      }
      </Button>
  );
}
